module.exports = __webpack_public_path__ + "img/CreateTemplate-Plus-Icon.668b356c.svg";